module.exports = __webpack_public_path__ + "img/SparkofGenius.1be11372.png";